import { createContext, useContext } from 'react';

export const PatientRecordContext = createContext();

export const usePatientRecordContext = () =>
  useContext(PatientRecordContext);
